const getters = {
  current: (state) => state.current,
  account: (state) => state.account,
  connectionCount: (state) => state.connectionCount,
};

export { getters };
